import styled from 'styled-components'
import { Avatar } from '@components/Avatar'
import {backgroundOrange, darkOrange, black, textMuted, mutedGrey} from '@/theme/colors'
import { fontSizes, leading } from '@/theme/typography'

export { Button } from '@components/Button'

export const Description = styled.p`
    margin: 0 0 20px 0;
    font-size: ${fontSizes.caption};
    color: ${textMuted};
    line-height: ${leading.body};
`

export const CategoryList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

export const CategoryMain = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
`

export const CategoryTitle = styled.span`
    font-size: ${fontSizes.base};
    font-weight: 700;
    color: ${black};
`

export const CategorySubtitle = styled.span<{ $active: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: ${fontSizes.caption};
    color: ${({ $active }) => ($active ? darkOrange : mutedGrey)};
    font-style: ${({ $active }) => ($active ? 'normal' : 'italic')};
    font-weight: ${({ $active }) => ($active ? 600 : 400)};
`

export const Chevron = styled.span`
    color: ${mutedGrey};
    font-size: ${fontSizes.title};
    flex-shrink: 0;
`

export const AvatarStack = styled.span`
    display: inline-flex;
    align-items: center;
`

/** One face in the selected-members stack: overlaps the one before it, ringed in the row's ground. */
export const StackAvatar = styled(Avatar)`
    border-color: ${backgroundOrange};

    & + & {
        margin-left: -8px;
    }
`

export const StackOverflow = styled.span`
    margin-left: 6px;
    font-size: ${fontSizes.caption};
    color: ${darkOrange};
    font-weight: 700;
`

export const ButtonGroup = styled.div`
    display: flex;
    gap: 8px;
    width: 100%;
    justify-content: flex-end;
`

